import { NgClass,KeyValuePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AppIcons } from '../../../../shared/app.icons';
import { AppSettings } from '../../../../shared/app.settings';
import { CommonBindingDataService } from '../../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../../shared/services/entity.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';

@Component({
  selector: 'app-product-overview-details',
  standalone: true,
  imports: [ButtonModule, TranslateModule, DropdownModule, ChartModule, OverlayPanelModule, FormsModule,
    NgClass, KeyValuePipe],
  templateUrl: './overview-details.component.html',
  styleUrl: './overview-details.component.scss'
})
export class ProductOverviewDetailsComponent implements OnInit, OnChanges {
  miIcons = AppIcons;
  iconPos: any = 'right';
  @Input() attributeValues: any;
  @Input() packTypeValue: any;
  @Input() storageValue: any;
  @Input() attributeLabels: any;
  @Input() productAttributeData: any;
  @Input() productEntityId;
  @Input() productRowData;
  @Input() productDetails;
  @Input() isDeleted: boolean = false;
  @Input() isUnassigned: boolean = false;
  @Output() onToggleOverLay: EventEmitter<boolean> = new EventEmitter();  
  dd_MMM_yyyy_FORMAT: any = AppSettings.dd_MMM_yyyy_hh_mm_FORMAT2;

  dropDownItems: any[] = [];
  selectedItem: any = [];
  data: any;
  options: any;
  tab: any;
  details: any;
  center: google.maps.LatLngLiteral = {
    lat: 24,
    lng: 12,
  };
  zoom = 4;
  map: google.maps.Map;
  bulkRowCount = 1;
  barcodeImage;
  visiblePrintLabel: boolean = false;
  rowData;
  isLoading: boolean = false;
  selectedEventId: any;
  eventLat: any;
  eventLng: any;
  marker: any;
  regionGeofences: any = [];
  zoneIds: any = [];
  fields: any;
  regionGeofence: any;
  matchedZoneDisplayName: string = '';

  constructor(public vehicleService: EntityService,
    public cs: CommonBindingDataService,
    private router: Router,
    public metaDataService: MetaDataService
  ) { }

  ngOnChanges() {
    this.rowData = this.productRowData;
  }

  ngOnInit() {

  }

  scrollToTop() {

    const tabviewPanels = document.querySelector('.p-tabview-panels');
    if (tabviewPanels) {
      tabviewPanels.scrollTop = 0;
    }
  }

  redirectToEdit() {
    this.router.navigate([`/app/products/add-product/${  this.productDetails.entityId}`]);
  }
}
